import { normalizeValue } from '../helpers.js';

export default {
  getVisitorId: state => {
    return state.visitorId;
  },
  getLang: state => {
    return state.lang;
  },
  getLastHttpAction: state => {
    return state.lastHttpAction;
  },
  getHasStarted: state => {
    return state.stationStartTimestamp ? true : false;
  },

  getShowLoadindicator: state => {
    return state.showLoadindicator;
  },
  getDataLoadError: state => {
    return state.dataLoadError;
  },

  getStationIntroTrack: state => {
    if (state.cmsData)
      return state.cmsData.intro_track;
  },
  getStationHeading: state => {
    if (state.cmsData)
      return state.cmsData.heading;
  },
  getStationScrrenState: state => {
      return state.screenState;
  },
  getStationIntro: state => {
    if (state.cmsData)
      return state.cmsData.intro_text;
  },

  getTracks: state => {
    if (state.cmsData)
      return state.cmsData.tracks;
  },
  getCurrentPlayerTrack: state => {
    if (state.cmsData)
      return state.cmsData.tracks.find(item => item.slug === state.player.currentTrackId);
  },
  getCurrentPlayerTime: state => {
    return state.player.currentTime;
  },
  getPlayingState: state => {
    return state.player.isPlaying;
  },
  getInfoPage: state => {
    if (state.cmsData)
      return state.cmsData.infobutton;
  },
  
  getStatisticsTotals: state => {
    let duration = 0,
        clicks = 0;

    if (state.stationStartTimestamp && state.stationEndTimestamp) {
      duration = state.stationEndTimestamp - state.stationStartTimestamp
    }

    clicks = state.clickCount;

    const normalized = {
      score: 1, 
      duration: normalizeValue(duration, 0, 600000), // 0 – 10 minutes
      activity: normalizeValue(clicks, 0, 50),
    }

    return { duration, clicks, normalized };
  },
};